<template>
    <div>
        <loading v-if="loading"></loading>
        <div v-else class="grid grid-cols-1 xl:grid-cols-2 gap-16">
            <div v-if="!boosters.length" class="flex justify-center col-span-2">
                <span>{{ $t('general.no_results') }}</span>
            </div>
            <div v-else v-for="booster in boosters" class="h-full">
                <div class="flex flex-col justify-between rounded border p-24 h-564 overflow-hidden shadow">
                    <div>
                        <div class="flex justify-center items-center bg-primary rounded py-2 mb-24">
                            <p class="text-white">{{ $t('multi-posting.campaigns.social_boost') }}</p>
                        </div>
                        <div class="flex justify-between mb-8">
                            <p>{{ `${booster.duration} ${$tc('general.days', booster.duration)}` }}</p>
                            <p>{{ currency.sign + booster.price.toFixed(2) }}</p>
                        </div>
                        <div class="flex items-center">
                            <svg-icon type="material-clock" class="w-16 h-16 mr-8" />
                            <span class="lowercase">5 {{ $tc('general.working_days', 5) }}</span>
                        </div>
                    </div>
                    <div class="flex justify-center items-center w-full h-156">
                        <img :src="booster.icon" :alt="`logo-${booster.title[locale]}`" class="max-h-156">
                    </div>
                    <div class="my-16">
                        <p class="text-body my-8">{{ booster.title[locale] }}</p>
                        <div class="flex items-center">
                            <p class="mr-4">{{ $t('boosters.share.media') }}:</p>
                            <svg-icon v-if="booster.media['google']" type="google" class="w-16 h-16 mr-5" />
                            <img v-if="booster.media.instagram" src="/app/img/instagram.svg" alt="Instagram" class="w-16 h-16 mr-5">
                            <svg-icon  v-if="booster.media['facebook-large']" type="facebook" class="w-16 h-16 mr-5" />
                        </div>
                    </div>
                    <div class="flex flex-col items-stretch gap-12 w-full">
                        <simple-button
                            v-if="isSelectedItem(booster.id)"
                            display="danger"
                            look="primary"
                            class="grow w-full"
                            @click="removeFromCampaign(booster)"
                        >
                            {{ $t('multi-posting.campaigns.form.remove_from_campaign') }}
                        </simple-button>
                        <simple-button
                            v-else
                            display="secondary"
                            look="primary"
                            class="grow w-full"
                            @click="addToCampaign(booster)"
                        >
                            {{ $t('multi-posting.contracts.index.add_to_campaign') }}
                        </simple-button>

                        <simple-button
                            display="primary"
                            class="grow w-full"
                            @click="moreInformation(booster)"
                        >
                            {{ $t('general.more_information') }}
                        </simple-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Loading from "../../ui/Loading.vue";
import SimpleButton from "../../ui/SimpleButton.vue";
import Booster from "../../../models/Booster";
import SvgIcon from "../../ui/SvgIcon.vue";
import {getSymbol} from "../../../etc/currency";
import {mapActions, mapState} from "pinia";
import {useMainStore} from '../../../state/store';
import {useMultiPostingStore} from '../../../state/modules/multiPosting';

export default {
    name: 'Boosters',
    components: {SimpleButton, Loading, SvgIcon},
    props: {
        selectedItems: { type: Array, required: true },
        boosters: { type: Array, required: true },
        loading: { type: Boolean, required: true },
    },
    computed: {
        ...mapState(useMainStore, ['locale']),
        currency() {
            return getSymbol();
        },
    },
    methods: {
        ...mapActions(useMultiPostingStore, ['removeSelectedItemById', 'addSelectedItems']),
        isSelectedItem(boosterId) {
            return this.selectedItems.filter(x => x.id == boosterId).length > 0;
        },
        addToCampaign(booster) {
            if (this.isSelectedItem(booster.id)) {
                return;
            }
            this.addSelectedItems([{
                id: booster.id,
                name: booster.title[this.locale],
                duration: {
                    period: booster.duration
                },
                price: {
                    amount: booster.price,
                    currency: 'EUR'
                },
                type: 'socialChannel',
            }]);
        },
        removeFromCampaign(channel) {
            this.removeSelectedItemById({itemId: channel.id});
        },
        moreInformation(booster)  {
            this.$emit('more-information', booster);
        },
    },
}
</script>
